import { render, staticRenderFns } from "./Review.vue?vue&type=template&id=523a9b7e&scoped=true"
import script from "./Review.vue?vue&type=script&lang=js"
export * from "./Review.vue?vue&type=script&lang=js"
import style0 from "./Review.vue?vue&type=style&index=0&id=523a9b7e&prod&lang=css"
import style1 from "./Review.vue?vue&type=style&index=1&id=523a9b7e&prod&scoped=scoped&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "523a9b7e",
  null
  
)

export default component.exports